// BackButton.js
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './style/BackButton.css';

const BackButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  if (location.pathname === '/') {
    return null;
  }


  return (
    <div className="fixed-back-button-container">
      <button onClick={() => navigate(-1)} className="back-button">
        ◀ Back
      </button>
    </div>
  );
};

export default BackButton;